import React from "react";
import { CellData } from "./table";
import { TableCell } from "./tableCell/tableCell";

interface TableBodyProps {
  computedCellData: CellData[][];
  tableDataToRender: any[];
  tableWidth: number;
  onRowClick: (rowData: any, actionHandlerName: string) => void;
  onDeleteIconClick?: (data: any) => void;
  onEditIconClick?: (data: any) => void;
  toggleCheckboxSelection?: (id: string) => void;
  onTableRowUpdate?: (rowIndex: number, fieldKey: string, newValue: any) => void;
  startIndex?: number;
  onChangeEmit?: (data: { name: string; required: boolean; value: boolean }) => void;
  rowClassName?: string | ((rowData: any, rowIndex: number) => string);
}

const TableBody: React.FC<TableBodyProps> = ({
  computedCellData,
  tableDataToRender,
  tableWidth,
  onRowClick,
  onDeleteIconClick,
  onEditIconClick,
  toggleCheckboxSelection,
  onTableRowUpdate,
  startIndex,
  onChangeEmit,
  rowClassName,
}) => {
  const handleTableRowUpdate = (rowIndex: number, fieldKey: string, newValue: any) => {
    onTableRowUpdate?.(rowIndex, fieldKey, newValue);
  };

  return (
    <tbody>
      {computedCellData.map((rowData, rowIndex) => {
        const currentRow = rowData[0]?.rowData;
        const extraRowClass =
          typeof rowClassName === "function"
            ? rowClassName(currentRow, rowIndex)
            : (rowClassName ?? "");
        return (
          <tr
            key={rowIndex}
            style={{ display: "flex", width: "100%" }}
            className={extraRowClass}
          >
            {rowData.map((cell, cellIndex) => (
              <td
                key={cellIndex}
                className={`table-cell ${cell.type}__${cell.header}`}
                style={{ width: `${cell?.width}%` }}
                onClick={() =>
                  onRowClick(
                    tableDataToRender[(startIndex ?? 0) + rowIndex],
                    cell.actionHandlerName ?? cell.header ?? "",
                  )
                }
              >
                <TableCell
                  type={cell.type}
                  id={cell.rowData?.id}
                  value={cell.value}
                  header={cell.header}
                  rowIndex={rowIndex}
                  globalRowIndex={startIndex ? startIndex + rowIndex : rowIndex}
                  rowData={cell.rowData}
                  handleDeleteIconClick={onDeleteIconClick}
                  handleEditIconClick={onEditIconClick}
                  toggleCheckboxSelection={toggleCheckboxSelection}
                  onTableRowUpdate={handleTableRowUpdate}
                  onChangeEmit={onChangeEmit}
                />
              </td>
            ))}
          </tr>
        );
      })}
    </tbody>
  );
};

export default TableBody;
